/*
  Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

  This software is the confidential and proprietary information of Wells Fargo
  bank. ('Confidential Information'). You shall not disclose such Confidential
  Information and shall use it only in accordance with the terms of the license
  agreement you entered into with WellsFargo.

  Author: Thomas Barry

  Description
  -----------
  Returns a boolean indicating whether the element is fully scrolled to the bottom
*/
export default (function (element) {
  var scrollHeight = element.scrollHeight,
      scrollTop = element.scrollTop,
      clientHeight = element.clientHeight;
  return scrollHeight - scrollTop <= clientHeight;
});